import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router'
import {
  Container,
  Header,
  HeaderButton,
  Main,
  BottomNav,
  BottomNavContainer,
  NavButton,
  Spacer,
} from './styled';

import { Bars, ChevronLeft } from '../../../../assets/icons'

import useIsMobile from '../../../../hooks/useIsMobile';
import colors from '../../../../styled/colors';
import { getTitleFromPathname } from '../../../../utils/getCurrentRoute';
import { matchesNavigationPath } from '../../../../utils/matchesNavigationPath'
import { useHistory } from 'react-router-dom';
import { NavText, Title } from '../../text';
import { MOBILE_TABS } from '../../../../constants/accesByRolesGroup';
import { canAccessMenuItem } from '../../../../utils/accessControl';
import { useMobileBack } from '../../../../context/MobileBackContext';

const MobileLayout = ({ auth,children, location }) => {
  const history = useHistory();
  const { customBack } = useMobileBack();
  const [activeTab, setActiveTab] = useState('inicio');
  const route = location.pathname;
  const currentTitle = getTitleFromPathname(route) || '';
  const withoutHeader = route === '/inicio/ver-mas' || route === '/inicio';

  const handleBack = () => {
    if (customBack) {
      customBack();
      return;
    }
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push('/inicio');
    }
  };
  
  const getTabsAvailable = () => {
    const userRoles = auth.gruposRoles || []

    let tabs = []
    userRoles.forEach(role => {
      const group = Object.keys(MOBILE_TABS).find(key => key === role)
      if (group && MOBILE_TABS[group]) {
        tabs = tabs.concat(MOBILE_TABS[group])
      }
    })
    const mobileAccessibleTabs = tabs.filter(item => canAccessMenuItem(item, auth))
    const bottomTabs = mobileAccessibleTabs.filter(item => item.mobileTab !== 'more')
    const hasMoreTab = mobileAccessibleTabs.some(item => item.mobileTab === 'more')

    const finalTabs = hasMoreTab
      ? [
          ...bottomTabs,
          {
            id: 'mas',
            label: 'Más',
            icon: Bars,
            path: '/inicio/ver-mas'
          }
        ]
      : bottomTabs

    return finalTabs
      .map(item => ({
      id: item.id,
      label: item.mobileLabel || item.label,
      icon: item.mobileIcon || item.icon,
      path: item.path,
      relatedPaths: (item.subRoutes || []).map(subRoute => subRoute.path),
      roles: item.roles
    }))
  }

  useEffect(() => {
    const tabs = getTabsAvailable();
    const found = tabs.find(tab =>
      matchesNavigationPath(location.pathname, tab.path, tab.relatedPaths)
    )

    setActiveTab(found ? found.id : '')
  }, [location.pathname]);

  const handleNavigation = (path, id) => {
    setActiveTab(id);
    history.push(path);
  };

  return (
    <Container>
      {!withoutHeader && (
        <Header>
          <HeaderButton onClick={handleBack}>
            <ChevronLeft size={15} color={colors.text.primaryText} />
          </HeaderButton>
          <Title size="18px" color="#000000ff">{currentTitle}</Title>
          <Spacer width="0.6" />
        </Header>
      )}
      <Main padding={route === '/inicio/ver-mas' && '0'}>{children}</Main>
      <BottomNav>
        <BottomNavContainer>
          {getTabsAvailable().map((tab) => {
            const Icon = tab.icon;
            return (
              <NavButton
                key={tab.id}
                active={activeTab === tab.id}
                onClick={() => handleNavigation(tab.path, tab.id)}
              >
                <Icon
                  size={24}
                  color={
                    activeTab === tab.id
                      ? colors.brand.selectGreen
                      : colors.text.primaryText
                  }
                />
                <NavText>{tab.label}</NavText>
              </NavButton>
            );
          })}
        </BottomNavContainer>
      </BottomNav>
    </Container>
  );
};

export default withRouter(MobileLayout);
